<script>
export default {
    name: 'RestaurantSkeleton',
}
</script>
<template lang="pug">
.restaurant-page.pt-md-page.pb-md-page
    .row
        .col-12.col-md-8
            image-wrapper.restaurant-cover(:height="coverHeight")
        .col-md-4
            .restaurant-details.d-flex.flex-column.overflow-hidden.mt-6.mt-md-0.h-100
                .d-flex.align-items-center.justify-content-between.mb-3
                h1.mb-0 Club Szendvics
                .d-flex.flex-md-wrap.align-items-baseline
            
        .col-12.col-md-8
            .nav.nav-pills.nav-secondary.mb-5
        
            .row.mx-lg-n3.mt-3.mt-lg-6.pt-2.row-stretch
                .col-12.col-xl-6.px-xl-3.mb-xl-5(v-for="index in 14")
                    .bg-f0.w-100(style="height: 150px;")
        .col-12.col-md-4
            .card.cart-block.border-radius-md-md.my-5.shadow-2
                .card-header.shadow-2.shadow-md-none.border-radius-top-md-md
                .bg-f0.border-radius-sm(style="height: 48px; width: 80px;")      
                    
                .card-body.cart-content
                .d-flex.flex-column.mb-6.mb-md-0
                    .py-5.py-lg-3(v-for="index in 3")
                        .bg-f0(height="24px" width="80")
                        .bg-f0(style="height: 14px; width: 60px;")
                        .bg-f0(style="height: 14px; width: 60px;")
                .card.border-radius-sm.mb-4.flat-card.mb-6.mb-md-0
                    .card-body.border-radius-sm.py-4
                    .bg-f0.w-100(style="height: 14px")
                    .grid
                        .d-flex.align-items-start(v-for="index in 2")
                            .bg-f0.rounded-circle(style="height: 14px; width: 60px;")
                            .bg-f0(style="height: 24px; width: 90px;")
                
                .card-footer.shadow-2.shadow-md-none.border-radius-bottom-md-md
                    .flex.justify-content-between(v-for="index in 3")
                    .bg-f0(style="height: 14px; width: 60px;")
                    .bg-f0(style="height: 14px; width: 60px;")
                    hr.card-separator
                    .flex.justify-content-between
                    .bg-f0(style="height: 14px; width: 60px;")
                    .bg-f0(style="height: 14px; width: 60px;")
        

</template>
